var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:[_vm.buttonClass, 'hidden-sm-and-down', 'fab-back-button'],attrs:{"fab":"","fixed":""},on:{"click":_vm.handleClick}},[_c('v-icon',[_vm._v("\n    "+_vm._s(_vm.getThemedVar('backButtonIcon', 'arrow_back'))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }